export default __webpack_public_path__ + "static/media/delete_icon.e8bde686.svg";